import { useEffect } from 'react'

import { navigate } from '@cedarjs/router'

import { useHomePage } from 'src/hooks/use-home-page'
import {
  useMyOrg,
  useIsGovWellStaff,
  useIsUnrestrictedGov,
} from 'src/layouts/AppStateContextLayout/utils'
import { FeatureGate, useFeatureFlagging } from 'src/utils/featureFlagging/featureFlagging'

type Props = {
  shouldHandleRedirect?: boolean
}

// The AutoCheck section is only visible to unrestricted GovWell staff who have at least one module with Application AutoCheck enabled.
export const useCanViewAutoCheckSection = ({ shouldHandleRedirect }: Props = {}) => {
  const isUnrestrictedGov = useIsUnrestrictedGov()
  const org = useMyOrg()
  const homePage = useHomePage()
  const isGovWellStaff = useIsGovWellStaff()

  const featureFlagging = useFeatureFlagging()

  const isAutoCheckSelfServeEnablementEnabled =
    featureFlagging.checkFeatureFlag(FeatureGate.AutoCheckSection) || isGovWellStaff

  const canViewAutoCheckPage =
    isUnrestrictedGov &&
    isAutoCheckSelfServeEnablementEnabled &&
    !!org?.hasRecordTypeWithApplicationAutoCheckEnabled

  useEffect(() => {
    if (shouldHandleRedirect && !canViewAutoCheckPage) {
      navigate(homePage)
    }
  }, [canViewAutoCheckPage, homePage, shouldHandleRedirect])

  return canViewAutoCheckPage
}
